import { render, staticRenderFns } from "./BoardCard.vue?vue&type=template&id=d6412996&scoped=true&"
import script from "./BoardCard.vue?vue&type=script&lang=js&"
export * from "./BoardCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardCard.vue?vue&type=style&index=0&id=d6412996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6412996",
  null
  
)

export default component.exports